import React from 'react';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import { message, Popconfirm, Modal, Icon } from 'antd';
import { SmallPopover, modal } from 'icsoc-antd-ex';
import IconFont from 'Components/common/iconFont';
import UnionTableList from 'Components/union/unionTableList';
import CommonTable from 'Components/common/commonTable';
import TableBottomActions from 'Components/common/commonTable/tableBottomActions';
import DetailDrawer from 'Components/detailDrawer';
import tDetailActions from 'Actions/taskManage/detail';
import sort from 'Utils/sort';
import timeFormat from 'Utils/timeFormat';
import moment from 'moment';
import { progress, status, result, result2, taskStatu } from './config';
import login from '../../../reducers/login';

const { modalTips } = modal;

class TableList extends UnionTableList {
  constructor(props) {
    super(props);

    this.state = {
      isDetailDrawerVisible: false, // 详情抽屉是否显示
      rowId: -1, // 当前点击的表格行id
      detailDrawerLoading: false, // 详情抽屉loading
      lastTimeL: 0,//通话时长
      contentsList: [
        {
          name: '暂停',
          action: () => {
            this.batch('pause');
          },
        },
        {
          name: '继续',
          action: () => {
            this.batch('continue');
          },
        },
        {
          name: '选中取消',
          is_no_disabled: true,
          action: () => {
            this.batch('cancel');
          },
        }
        // ,
        // {
        //   name: '呼叫',
        //   action: () => {
        //     this.batch('call');
        //   },
        // },
      ]
    };
    this.custom_column = []
  }

  componentWillMount() {
    this.customize = localStorage.getItem('customize') || '';
  }

  handleAction = (type, id) => {
    this[type](id);
  };

  // 列表选择
  onSelectChange = selectedRowKeys => {
    const { actions } = this.props;
    actions.setSelectdRowKeys(selectedRowKeys);
    const { contentsList } = this.state;
    // if(selectedRowKeys.length>0){
    //   contentsList[2].name='选中取消';
    // }else{
    //   contentsList[2].name='全部取消';
    // }
    this.setState({ contentsList });
  };

  // 批量操作
  batch = type => {
    const that = this;
    const { selectedRowKeys, actions, setTableListLoading } = this.props;
    let action = 'batchPause';
    let str = '暂停';

    switch (type) {
      case 'pause':
        action = 'batchPause';
        str = '暂停';
        break;
      case 'continue':
        action = 'batchContinue';
        str = '继续';
        break;
      case 'cancel':
        action = 'batchCancel';
        str = '取消';
        break;
      // case 'call':
      //   action = 'batchCall';
      //   str = '呼叫';
      //   break;
      default:
        break;
    }
    if (action == 'batchCancel') {
      if (selectedRowKeys.length == 0) {
        return;
      }

      Modal.confirm({
        title: '取消提示',
        icon: <Icon type="close-circle" style={{ color: 'red' }} />,
        content: '确定要取消选中数据吗？取消后，数据将无法恢复，请谨慎操作！',
        onOk() {
          setTableListLoading();
          if (selectedRowKeys.length == 0) {

            // actions.batchCancelAll().then(res=>{
            //   const {
            //     payload: {code, data = []},
            //   } =
            //     res || {};
            //     if (parseInt(code, 10) === 200) {
            //       if (data instanceof Array && data.length > 0) {
            //         modalTips({
            //           centered: true,
            //           className: 'batch-modal-confirm',
            //           title: '提示',
            //           content: (
            //             <div className="taskManage-detail-tipsContent">
            //               {data.map(item =>
            //                  (<p>{item} </p>)
            //               )}
            //             </div>
            //           ),
            //           okText: '我知道了',
            //           onOk() {
            //             that.batchCallBack();
            //           },
            //         });
            //       } else {
            //         message.success('操作成功！');
            //         that.batchCallBack();
            //       }
            //     } else {
            //       that.batchCallBack();
            //     }
            // })
          } else {
            actions[action](selectedRowKeys).then(res => {
              const {
                payload: { code, data = [] },
              } =
                res || {};

              if (parseInt(code, 10) === 200) {
                if (data instanceof Array && data.length > 0) {
                  modalTips({
                    centered: true,
                    className: 'batch-modal-confirm',
                    title: '提示',
                    content: (
                      <div className="taskManage-detail-tipsContent">
                        {data.map(item => {
                          const { taskName = '', phone = '', taskStatus, status } =
                            item || {};

                          return (
                            <p>
                              {`${taskName}，客户号码${phone}，无法${str}，客户${taskStatus !== 2 && taskStatus !== 3
                                  ? progress[status]
                                  : taskStatu[taskStatus]
                                }`}
                            </p>
                          );
                        })}
                      </div>
                    ),
                    okText: '我知道了',
                    onOk() {
                      that.batchCallBack();
                    },
                  });
                } else {
                  message.success('操作成功！');
                  that.batchCallBack();
                }
              } else {
                that.batchCallBack();
              }
            });
          }
        },
      });
    } else {
      setTableListLoading();
      actions[action](selectedRowKeys).then(res => {
        const {
          payload: { code, data = [] },
        } =
          res || {};

        if (parseInt(code, 10) === 200) {
          if (data instanceof Array && data.length > 0) {
            modalTips({
              centered: true,
              className: 'batch-modal-confirm',
              title: '提示',
              content: (
                <div className="taskManage-detail-tipsContent">
                  {data.map(item => {
                    const { taskName = '', phone = '', taskStatus, status } =
                      item || {};

                    return (
                      <p>
                        {`${taskName}，客户号码${phone}，无法${str}，客户${taskStatus !== 2 && taskStatus !== 3
                            ? progress[status]
                            : taskStatu[taskStatus]
                          }`}
                      </p>
                    );
                  })}
                </div>
              ),
              okText: '我知道了',
              onOk() {
                that.batchCallBack();
              },
            });
          } else {
            message.success('操作成功！');
            that.batchCallBack();
          }
        } else {
          that.batchCallBack();
        }
      });
    }
  };

  batchCallBack = () => {
    const { actions, getTableList, pageStatus, searchData } = this.props;
    const { contentsList } = this.state;
    // contentsList[2].name='全部取消';
    this.setState({ contentsList });

    actions.setSelectdRowKeys([]);
    getTableList({ ...pageStatus, ...searchData }, 'withoutLoading');
  };

  // 拨打电话
  confirmCall = id => {
    const {
      actions,
      setTableListLoading,
      getTableList,
      pageStatus,
      searchData,
    } = this.props;

    setTableListLoading();
    actions
      .confirmCall(id)
      .then(res => {
        const { payload: { code = '' } = {} } = res || {};

        if (parseInt(code, 10) === 200) {
          message.success('已加入拨打计划，稍后可到列表查看详情！');
          getTableList({ ...pageStatus, ...searchData });
        }
      })
      .finally(() => {
        setTableListLoading();
      });
  };

  // 显示通话详情抽屉
  showDetailDrawer = (record, type) => {
    const { actions } = this.props;

    this.setState({
      rowId: record.id,
      lastTime: record.lastTime,
      detailDrawerLoading: true,
    });

    actions.getDetailDrawerData(record.id).then(res => {
      if (type !== 'onRow') {
        this.setState({
          isDetailDrawerVisible: true,
        });
      }
    }).finally(() => {
      this.setState({
        detailDrawerLoading: false,
      });
    });
  };

  // 关闭通话详情抽屉
  closeDetailDrawer = () => {
    this.setState({
      rowId: -1,
      isDetailDrawerVisible: false,
    });
  };

  reset_custom_column(cb) {
    this.custom_column = [];
    cb && cb();
  }
  getHeaderCustomColumn = (taskId, cb) => {
    const { getHeaderCustomColumn } = this.props.actions;
    getHeaderCustomColumn(taskId).then(res => {
      const { code, data } = res.payload;
      if (code === 200) {
        this.custom_column = data;
        cb && cb();
      }
    }).catch(err => {
      this.custom_column = []
      cb && cb();
    })
  }
  componentDidMount() {
    this.props.onRef(this);
  }

   // 更新信息抽取字段值
   saveExtractField = (params) => {
    const { actions } = this.props;
    this.setState({
      detailDrawerLoading: true
    })
    actions
    .updateSlotMapVal(params)
    .then(() => {
      actions.getDetailDrawerData(params.jobId)
    })
    .finally(()=>{
      this.setState({
        detailDrawerLoading: false
      })
    })
  }

  render() {
    const me = this;
    const {
      selectedRowKeys,
      tableListData: { data = [], total = 0 } = {},
      loading,
      pageStatus,
      detailDrawerData,
      login,
    } = this.props;
    const { rowId, isDetailDrawerVisible, detailDrawerLoading, contentsList, lastTime } = this.state;
    const columns = (pageStatus, handleAction) => {
      let arr = [
        {
          title: '序号',
          key: 'key',
          dataIndex: 'key',
          width: 80,
          fixed: 'left',
          render: (text, record, index) => {
            const { pageNum, pageSize } = pageStatus;

            return sort({ pageNum, pageSize, index });
          },
        },
        {
          title: '呼叫标识',
          dataIndex: 'id',
          key: 'id',
          width: 160,
          fixed: 'left',
          render: text => text || '--',
        },
        // {
        //   title: '批次名',
        //   dataIndex: 'batchName',
        //   key: 'batchName',
        //   width: 160,
        //   render: text => (text && text !== null ? text : '--'),
        // },
        // {
        //   title: '批次呼叫次数',
        //   dataIndex: 'batchNum',
        //   key: 'batchNum',
        //   width: 160,
        //   render: (text, record) =>
        //     text && text !== null && record.batchName !== null ? text : '--',
        // },
        {
          title: '第三方标识',
          dataIndex: 'clientName',
          key: 'clientName',
          width: 100,
          render: text => text || '--',
        },
        {
          title: '主叫号码',
          dataIndex: 'callNumber',
          key: 'callNumber',
          width: 150,
          render: text => text || '--',
        },
        {
          title: '电话号码',
          dataIndex: 'phone',
          key: 'phone',
          width: 150,
          render: text => text || '--',
        },
        {
          title: '联系进度',
          dataIndex: 'progress',
          key: 'progress',
          width: 110,
          render: text => progress[text] || '--',
        },
        {
          title: '任务名称',
          dataIndex: 'taskName',
          key: 'taskName',
          width: 140,
          render: text => text || '--',
          ellipsis: true,
        },
        {
          title: '联系结果',
          dataIndex: 'result',
          key: 'result',
          width: 120,
          render: text => {

            let user = localStorage.getItem('user') || '{}';
            user = JSON.parse(user)
            const vccId = user?.profile?.vcc_id

            if (['2002361', '1018'].includes(vccId)) {
              return result2[text] || '--';
            }
            return result[text] || '--';
          },
        },
        // {
        //   title: '标签',
        //   dataIndex: 'tag',
        //   key: 'tag',
        //   width: '4%', // 70
        //   render: text => text || '--',
        // },
        {
          title: '通话时长',
          dataIndex: 'lastTime',
          key: 'lastTime',
          width: 120,
          render: text => timeFormat(text),
        },
        {
          title: '提交时间',
          dataIndex: 'commitTime',
          key: 'commitTime',
          width: 200,
          render: text =>
            (text && moment(text).format('YYYY-MM-DD HH:mm:ss')) || '--',
        },
        {
          title: '呼出时间',
          dataIndex: 'callTimestamp',
          key: 'callTimestamp',
          width: 200,
          render: text =>
            (text && moment(text).format('YYYY-MM-DD HH:mm:ss')) || '--',
        },
        {
          title: '次数',
          dataIndex: 'callIndex',
          key: 'callIndex',
          width: 120,
          render: text => (text && `第${text}次`) || '--',
        },
        {
          title: '回调状态',
          dataIndex: 'reason',
          key: 'reason',
          width: 120,
          render: text => {
            let word = '';
            const hasCallback = [
              'transfer_callback_success',
              'hangup_callback_success',
              'rePush_callback_success',
            ];
            if (hasCallback.includes(text)) {
              word = '已回调';
            } else if (text === 'no_need_callback_success') {
              word = '不回调';
            } else if (text) {
              word = '回调失败';
            } else {
              word = '--';
            }
            return word;
          },
        },
        {
          title: '回调时间',
          dataIndex: 'callbackTime',
          key: 'callbackTime',
          width: 200,
          render: text =>
            (text && moment(text).format('YYYY-MM-DD HH:mm:ss')) || '--',
        },
        {
          title: '接收到挂机消息的时间',
          dataIndex: 'receiveTime',
          key: 'receiveTime',
          width: 200,
          render: text =>
            (text && moment(text).format('YYYY-MM-DD HH:mm:ss')) || '--',
        },
        {
          title: '通话结束时间',
          dataIndex: 'hangupTime',
          key: 'hangupTime',
          width: 200,
          render: text =>
            (text && moment(text).format('YYYY-MM-DD HH:mm:ss')) || '--',
        },
      ];
      if (this.customize === 'xy') {
        arr.push({
          title: 'UID',
          dataIndex: 'uid',
          key: 'uid',
          width: 200,
          render: text => text || '--',
        });
      }
      const lastCols = [
        this.customize === 'txgg'
          ? {}
          : {
            title: '有效通话轮次',
            dataIndex: 'usefulInteractNum',
            key: 'usefulInteractNum',
            width: 120,
            render: text => String(text) || '--',
          },
        this.customize === 'txgg'
          ? {}
          : {
            title: '通话轮次',
            dataIndex: 'interactNum',
            key: 'interactNum',
            width: 120,
            render: text => String(text) || '--',
          },
        this.customize === 'xy'
          ? {
            title: '意向标签',
            dataIndex: 'code',
            key: 'code',
            width: 150,
            render: text => text || '--',
          }
          : {
              title: '有效标签',
              dataIndex: 'effectiveLabel',
              key: 'effectiveLabel',
              width: 150,
              render: text => text || '--',
            },
        this.customize === 'xy'
          ? {
            title: '人工纠错',
            dataIndex: 'correctResult',
            key: 'correctResult',
            width: 180,
            render: text => text || '--',
          }
          : {},
        {
          title: '操作',
          width: 80,
          dataIndex: 'operate',
          key: 'operate',
          fixed: 'right',
          render: (text, record) => {
            const { result, status, progress } = record;
            const resultNum = parseInt(result, 10);
            const statusNum = parseInt(status, 10);
            const progressNum = parseInt(progress, 10);

            // 联系结果：接听后挂断、转人工 可以查看详情
            const isSeeDetailDisable =
              resultNum === 2 || resultNum === 5 || progressNum === 1
                ? ''
                : ' is-disable';
            // 任务状态：进行中或者已完成 并且 联系进度：已联系 可以拨打电话
            const isCallDisable =
              (statusNum === 1 || statusNum === 4) && progressNum === 2
                ? ''
                : ' is-disable';

            return (
              <div className="operate">
                <SmallPopover
                  type="white"
                  content="查看详情"
                  className={`tooltip${isSeeDetailDisable}`}>
                  <IconFont
                    type="icon-robotdetails"
                    onClick={
                      isSeeDetailDisable === ' is-disable'
                        ? null
                        : () => handleAction('showDetailDrawer', record)
                    }
                  />
                </SmallPopover>
                {
                  login.permissionsList.includes('taskManageDetail.call') ?
                    <SmallPopover
                      type="white"
                      content="拨打电话"
                      className={`tooltip${isCallDisable}`}>
                      {isCallDisable ? (
                        <IconFont type="icon-robotexhale" />
                      ) : (
                        <Popconfirm
                          placement="leftBottom"
                          title="确认对该客户进行拨打吗?"
                          onConfirm={() => handleAction('confirmCall', record.id)}>
                          <IconFont type="icon-robotexhale" />
                        </Popconfirm>
                      )}
                    </SmallPopover>
                    : null}
              </div>
            );
          },
        },
      ].filter(item => JSON.stringify(item) !== '{}');
      if (me.custom_column.length > 0) {
        const customColums = me.custom_column.map(item => {
          return {
            title: item.name,
            dataIndex: item.key,
            key: item.key,
            width: 120,
            render: (text, { extColsMap }) => {
              return !!extColsMap[item.key] ? String(extColsMap[item.key]) : '--';
            },
          }
        });
        arr = arr.concat(customColums)
      }
      arr = arr.concat(lastCols);
      return arr;
    };



    let tableWidth = 3020;
    if (this.customize === 'xy') {
      tableWidth = 3370;
    } else if (this.customize === 'txgg') {
      tableWidth = 2600;
    }
    return (
      <React.Fragment>
        <CommonTable
          columns={columns(pageStatus, this.handleAction)}
          extraHeight={this.customize === 'txgg' ? 0 : 55}
          rowSelection={{
            selectedRowKeys,
            onChange: this.onSelectChange,
          }}
          dataSource={[...data]}
          rowKey={record => record.id}
          loading={loading}
          scroll={{ x: tableWidth }}
          onChange={this.handleTableChange}
          pagination={{
            current: pageStatus.pageNum,
            total: total && parseInt(total, 10),
            pageSize: pageStatus.pageSize,
            showTotal: () => (
              <TableBottomActions
                showTotalRender={`共 ${total} 条`}
                selects={selectedRowKeys.length}
                isMore={false}
                showButtons="2"
                contents={contentsList}
              />
            ),
          }}
          rowClassName={record => (rowId === record.id ? 'row-back' : '')}
          onRow={record => ({
            onClick: data => {
              if (
                data.target &&
                data.target.tagName !== 'use' &&
                data.target.tagName !== 'svg' &&
                isDetailDrawerVisible
              ) {
                if (
                  parseInt(record.result, 10) === 2 ||
                  parseInt(record.result, 10) === 5
                ) {
                  this.showDetailDrawer(record, 'onRow');
                } else {
                  this.closeDetailDrawer();
                }
              }
            },
          })}
        />

        {isDetailDrawerVisible ? (
          <DetailDrawer
            id={rowId}
            pageType="detail"
            lastTime={lastTime}
            loading={detailDrawerLoading}
            dataSource={detailDrawerData}
            onClose={this.closeDetailDrawer}
            onSaveExtractField={data => {
              this.saveExtractField(data)
            }}
          />
        ) : null}
      </React.Fragment>
    );
  }
}

const mapStateToProps = ({ taskManageDetail, login }) => ({
  tableListData: taskManageDetail.tableListData,
  pageStatus: taskManageDetail.pageStatus,
  searchData: taskManageDetail.searchData,
  selectedRowKeys: taskManageDetail.selectedRowKeys,
  detailDrawerData: taskManageDetail.detailDrawerData,
  login
});

const mapDispatchToProps = dispatch => ({
  actions: bindActionCreators(tDetailActions, dispatch),
});

export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(TableList);
